"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageAlignment = void 0;
var ImageAlignment;
(function (ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})(ImageAlignment = exports.ImageAlignment || (exports.ImageAlignment = {}));
//# sourceMappingURL=alignment.js.map